import { REF_H } from "../lib/organs";
import { SHAPES } from "./organs/anatomy";
import { OrganMat } from "./organs/shapes";

export const Organs = ({ organs, height, sex, subzone }) => {
  const anyActive = organs.some((o) => o.id === subzone);
  return (
    <group scale={height / REF_H}>
      {organs.map((o) => (
        <group key={o.id} userData={{ organ: o.id }}>
          {SHAPES[o.id](<OrganMat color={o.color} active={subzone === o.id} dim={anyActive && subzone !== o.id} />, sex)}
        </group>
      ))}
    </group>
  );
};
